import styled from 'styled-components';
import { colorTheme } from '../../../../core/configs';

export const StyledImg = styled.img`
  width: 100%;
  height: 40px;
  cursor: pointer;
`;

export const StyledOr = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const StyledLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colorTheme.lightGray};
`;
